import * as Yup from 'yup';

const initialValues = {
  doctorName: '',
  doctorPhone: '',
};

export type FormValues = {
  doctorName: string;
  doctorPhone: string;
};

export const validation = {
  initialValues,
  schema: Yup.object().shape({
    doctorName: Yup.string().required('Add your doctor’s name'),
    doctorPhone: Yup.string().required('Add your doctor’s phone number'),
  }),
};
